import axios from 'axios';
import qs from 'qs';
import { ceil, isEmpty } from 'lodash';

import { getAuth, signOut } from 'firebase/auth'

import { keycloakConfig } from '../utils/keycloak';
import { getUserInfo, saveKeycloakToken } from '../utils/tokenStorage';

export const refreshTokenOttWeb = async (keycloakInstance) => {
  if (!keycloakInstance?.refreshToken) return null;

  const { exp, iat } = JSON.parse(window.atob(keycloakInstance.token.split('.')[1]));
  const currentTimestamp = (new Date().getTime() / 1000)
  const timestampToRefresh = exp - ((exp - iat) * 0.1)

  if (timestampToRefresh <= ceil(currentTimestamp)) {
    const body = {
      grant_type: 'refresh_token',
      client_id: keycloakConfig.clientId,
      refresh_token: keycloakInstance.refreshToken
    };

    const headers = {
      headers: { 'content-type': 'application/x-www-form-urlencoded' },
      timeout: 10000
    };

    try {
      const { data } = await axios.post(
        `${keycloakConfig.url}realms/${keycloakConfig.realm}/protocol/openid-connect/token`,
        qs.stringify(body),
        headers
      )

      if (!data?.access_token) {
        return keycloakInstance;
      }

      keycloakInstance.token = data.access_token;
      keycloakInstance.refreshToken = data.refresh_token;
      if (data.id_token) keycloakInstance.idToken = data.id_token;

      saveKeycloakToken(keycloakInstance);
      if (isEmpty(localStorage.getItem('kcUserInfo'))) {
        await getUserInfo(keycloakInstance)
      }

      return keycloakInstance;
    } catch (e) {
      if (e.response?.status === 400 || e.response?.error_description === 'Session not active') {
        const auth = getAuth()
        signOut(auth)
        window.location.href = '/directing';
        localStorage.clear()
        return keycloakInstance;
      }

      if (new Date() >= new Date(exp * 1000)) {
        console.warn('Keycloak fuera de servicio o error de red.')
        throw Error("Tuvimos dificultades para validar tu acceso.\nPor favor, espera un momento y vuelve a intentarlo.")
      }
      return keycloakInstance
    }
  }
  saveKeycloakToken(keycloakInstance);
  if (isEmpty(localStorage.getItem('kcUserInfo'))) {
    await getUserInfo(keycloakInstance)
  }

  return keycloakInstance;
};
